/**
 * @generated SignedSource<<25441cd00f289b3b7ebeaad2d485cd8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useParticipantsOptions_viewer$data = {
  readonly account: {
    readonly emailDomainList: ReadonlyArray<string>;
    readonly isPersonalType: boolean;
  };
  readonly " $fragmentType": "useParticipantsOptions_viewer";
};
export type useParticipantsOptions_viewer$key = {
  readonly " $data"?: useParticipantsOptions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useParticipantsOptions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useParticipantsOptions_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPersonalType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailDomainList",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b2ee46ac58d7b913f909e2ece511ef47";

export default node;
